/**
 * Converts markdown-formatted text to a plain string suitable for aria-live
 * announcements. Screen readers should receive text only — HTML elements inside
 * live regions are not reliably announced across NVDA, JAWS, and VoiceOver.
 */
export function stripMarkdown(markdown: string): string {
  return (
    markdown
      // Fenced code blocks
      .replace(/```[\s\S]*?```/g, '')
      // Inline code
      .replace(/`[^`]*`/g, '')
      // Headings
      .replace(/^#{1,6}\s+/gm, '')
      // Bold / italic (handle *** before ** before *)
      .replace(/\*{3}([^*]+)\*{3}/g, '$1')
      .replace(/\*{2}([^*]+)\*{2}/g, '$1')
      .replace(/\*([^*]+)\*/g, '$1')
      .replace(/_{2}([^_]+)_{2}/g, '$1')
      .replace(/_([^_]+)_/g, '$1')
      // Links — keep the display text, drop the URL
      .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
      // Citation markers like [1], [2]
      .replace(/\[\d+\]/g, '')
      // Images
      .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
      // Blockquotes
      .replace(/^>\s*/gm, '')
      // Horizontal rules
      .replace(/^[-*_]{3,}\s*$/gm, '')
      // Unordered list markers
      .replace(/^[\s]*[-*+]\s+/gm, '')
      // Ordered list markers
      .replace(/^[\s]*\d+\.\s+/gm, '')
      // Collapse excess whitespace
      .replace(/\n{3,}/g, '\n\n')
      .trim()
  );
}
